<template>
  <div class="ExtraWorkManagementListWeb">
    <v-data-table
      dense
      :headers="headers"
      :items="list"
      :items-per-page="5"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :footer-props="{
        'items-per-page-options': [5, 10, 15, 50, 100, -1],
        'items-per-page-text': $t('rowsPerPage'),
        'show-first-last-page': true,
      }"
      @click:row="handleClick"
    >
      <!-- Header: Select All Checkbox -->
      <template v-slot:header.select="{}">
        <v-checkbox
          dense
          hide-details
          :input-value="areVisibleItemsAllSelected"
          @change="toggleSelectCurrentPage"
        />
      </template>

      <!-- Body: Display rows -->
      <template v-slot:body="{ items }">
        <tbody>
          <!-- Update visibleItems array to current page -->
          <template v-if="updateVisibleItems(items)" />
          <tr v-for="item in items" :key="item.Id" @click="handleClick(item)" style="cursor: pointer" :item="item">
            <td v-if="show">
              <v-checkbox
                dense
                hide-details
                v-model="item.select"
                @click.stop
              />
            </td>
            <td>{{ item.perno }}</td>
            <td>{{ item.personName }}</td>
            <td>{{ item.BEGINDATE }}</td>
            <td>{{ item.BEGINTIME }}</td>
            <td>{{ item.ENDDATE }}</td>
            <td>{{ item.ENDTIME }}</td>
            <td>{{ item.requestDate }}</td>
            <td>{{ item.Statustype }}</td>
            <td>{{ item.Dscp }}</td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  emits: ['onClick'],
  props: {
    list: {
      type: Array,
      required: true,
    },
    approved: Boolean,
    pagination: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
      visibleItems: [],
      headers: [
        { text: this.$t(""), value: "select", sortable: false }, // select checkbox
        { text: this.$t("card-no"), value: "perno" },
        { text: this.$t("person-name"), value: "personName" },
        { text: this.$t("BeginDate"), value: "BEGINDATE" },
        { text: this.$t("BeginTime"), value: "BEGINTIME" },
        { text: this.$t("EndDate"), value: "ENDDATE" },
        { text: this.$t("EndTime"), value: "ENDTIME" },
        { text: this.$t("RequestDate"), value: "requestDate" },
        { text: this.$t("status"), value: "Statustype" },
        { text: this.$t("description"), value: "Dscp" },
      ],
    };
  },
  computed: {
    areVisibleItemsAllSelected() {
      return (
        this.visibleItems.length > 0 &&
        this.visibleItems.every((item) => item.select === true)
      );
    },
  },
  methods: {
    updateVisibleItems(items) {
      // Ensure all visible items have `select` property
      items.forEach((item) => {
        if (item.select === undefined) this.$set(item, "select", false);
      });
      this.visibleItems = items;
      return true;
    },
    toggleSelectCurrentPage(value) {
      // Clear selection on all first
      this.list.forEach((item) => this.$set(item, "select", false));

      // Then only select items on the current page
      if (value) {
        this.visibleItems.forEach((item) => this.$set(item, "select", true));
      }
    },
     handleClick(item) {
      this.$emit("onClick", item);
    },
    checkApproved() {
      if (this.approved) {
        this.show = false;
        this.headers = this.headers.filter((h) => h.value !== "select");
      }
    },
  },
  mounted() {
    this.checkApproved();
  },
};
</script>
